import React, { FC } from "react";

export interface BgGlassmorphismProps {
  className?: string;
}

const BgGlassmorphism: FC<BgGlassmorphismProps> = ({
  className = "absolute inset-x-0 flex overflow-hidden z-0 h-screen",
}) => {
  return (
    <div
      className={`nc-BgGlassmorphism ${className}`}
      data-nc-id="BgGlassmorphism"
    >
      <span className="absolute top-[12rem] left-[5rem] bg-[#ef233c] w-72 h-72 rounded-full mix-blend-multiply filter blur-3xl opacity-10"></span>
      <span className="absolute bottom-[15rem] left-[15rem] bg-[#04868b] w-[30rem] h-[30rem] -ml-20 mt-40 rounded-full mix-blend-multiply filter blur-3xl opacity-10 nc-animation-delay-2000"></span>
	  
	  <span className="absolute top-[10rem] right-[15rem] bg-[#04868b] w-72 h-72  rounded-full mix-blend-multiply filter blur-3xl opacity-10 nc-animation-delay-2000"></span>
	  <span className="absolute bottom-[5rem] right-[5rem] bg-[#ef233c] w-[30rem] h-[30rem]  rounded-full mix-blend-multiply filter blur-3xl opacity-10 nc-animation-delay-2000"></span>
    </div>
  );
};

export default BgGlassmorphism;
